
// these competitions have been created before
// invoicing module has been released
export const ignoreForInvoicing = [
  '38e7a210-3470-11e9-bfac-020972181bca',
  '649e19d8-af53-11e8-9e4d-8c85901f3b73',
  '785f8069-e5f0-11e9-868a-0242ac110004',
  '82f53f0a-3ea7-11e9-a66a-020972181bca',
  'db8aa726-aa96-11e8-a969-8c85901f3b73',
  'f58b28d3-d88d-11e8-990a-027b1d34f62c'
]



//////////////////
// WEBPACK FOOTER
// ./src/lib/constants.js
// module id = 339
// module chunks = 1